<div class="container-fluid accounts-page">
    <div class="d-flex justify-content-between align-items-center accounts-header">
        <h3>Accounts</h3>
        <button mat-raised-button color="primary" (click)="createAccount()">Create account</button>
    </div>

    <div class="accounts-table">
        <!-- Single state display - handles both loading and empty -->
        <app-state-display
            *ngIf="isLoading || (!isLoading && filteredAccounts.length === 0)"
            [type]="isLoading ? 'loading' : 'empty'"
            loadingMessage="Loading accounts..."
            emptyMessage="No accounts found"
            emptyIcon="assignment">
        </app-state-display>

        <!-- Table content -->
        <app-custom-table
            *ngIf="!isLoading && filteredAccounts.length > 0"
            class="ag-theme-material"
            [rowData]="filteredAccounts"
            [columnDefs]="columns"
            [animateRows]="true"
            [pagination]="true"
            [hideGlobalFilter]="false"
            [showToolPanel]="true"
            [sideBar]="sideBar"
            [dropdownFilters]="dropdownFilters"
            [paginationAutoPageSize]="true">
        </app-custom-table>
    </div>
</div>
